@let fieldData = field();
@let formControl = control();
@let constraints = $constraints();
@let failedFileLikes = $failedFileLikes();

@if (formControl) {
  <div class="relative mb-6">
    <label tuiInputFiles="l" class="workflow-field">
      <input
        tuiInputFiles
        [formControl]="formControl"
        [multiple]="$multiple()"
        [maxFileSize]="constraints.maxFileSizeBytes"
        [accept]="constraints.accept"
        (change)="formControl.markAsTouched()"
        (reject)="onReject($event)"
      />
      <ng-template>
        <span class="text-(--tui-text-action)">{{ fieldData.title }}</span>
        @if (fieldData.helpText) {
          <span class="block x-font-body-5">{{ fieldData.helpText }}</span>
        }
      </ng-template>
    </label>

    <tui-files class="mt-1" [max]="5">
      @if (formControl.value) {
        @for (file of getFiles(); track file) {
          @let failedFile = failedFileLikes.get(file);
          @if (failedFile) {
            <tui-file
              class="whitespace-pre-wrap!"
              state="error"
              [file]="failedFile"
              [showDelete]="formControl.enabled"
              (remove)="removeFile(file)"
            />
          } @else {
            <tui-file
              class="whitespace-pre-wrap!"
              [file]="file"
              [showDelete]="formControl.enabled"
              (remove)="removeFile(file)"
            />
          }
        }
      }

      @for (file of rejectedFiles(); track file) {
        <tui-file
          state="error"
          [file]="file"
          [showDelete]="formControl.enabled"
          (remove)="clearRejected(file)"
        />
      }
    </tui-files>

    @if (formControl.invalid && (formControl.dirty || formControl.touched)) {
      <div class="x-text-wf-error x-font-body-5 mt-1 absolute">
        @if (formControl.hasError('required')) {
          <span>Обязательное поле</span>
        }
        @if (formControl.hasError('minArrayLength')) {
          <span
            >Минимальное количество файлов:
            {{ formControl.getError('minArrayLength').min }}</span
          >
        }
        @if (formControl.hasError('maxArrayLength')) {
          <span
            >Максимальное количество файлов:
            {{ formControl.getError('maxArrayLength').max }}</span
          >
        }
        @if (formControl.hasError('invalidMimetypes')) {
          <span>Недопустимый тип файла</span>
        }
        @if (formControl.hasError('customError')) {
          <span>Ошибка валидации</span>
        }
      </div>
    }
  </div>
}
